<template>
  <div class="card shadow">
    <div class="card-header border-0 dark">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0 sub_title">
            Lista de Repartidores
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" class="btn_create" @click="ShowDealer">
            Crear Repartidor
          </base-button>
          <CreateDealers/>
          <rute></rute>
        </div>
      </div>
    </div>

    <div class="table-responsive table-flush">
      <base-table class="table align-items-center"
                  thead-classes="table-light"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th>Nombre</th>
          <th>Apellido</th>
          <th>Teléfono</th>
          <th>Email</th>
          <th>Tipo</th>
          <th>Estado</th>
          <th>Rutero</th>
          <th colspan="2"></th>

        </template>
        <template slot-scope="{row}" >
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{ row.name }}</span>
              </div>
            </div>
          </th>
          <td class="budget">
            {{ row.last_name }}
          </td>
          <td class="budget">
            {{ row.phone }}
          </td>
          <td class="budget">
            {{ row.email }}
          </td>
          <td class="budget">
            <div v-for="(item,index) in row.user_type_id" :key="item.id" v-show="index ==='user_type_name'">
              {{ item }}
            </div>
          </td>
          <td class="budget">
                        <span v-if="row.user_status == 1">
                            Activo
                        </span>
            <span v-else>
                            Desactivado
                        </span>
          </td>
          <td>
            <div class="btn_icon_rute" @click="OpenRute(row.user_id)"></div>
          </td>
          <td>
            <div class="btn_icon_edit" @click="EditUser(row.user_id)"></div>
          </td>
          <td><div class="btn_icon_delete" @click="DeleteUser(row.user_id)"></div></td>
        </template>
      </base-table>
    </div>
    <div class="card-footer">
      <base-pagination align="center" v-model="value" :page-count="page_count"></base-pagination>
    </div>

  </div>
</template>

<script>
import {bus} from './bus-dealers'
import CreateDealers from "./CreateDealers";
import _ from "lodash";
import {dealers_service} from "../../services/dealers/DealersService";
import Rute from "@/components/Dealers/rute";
import swal from "sweetalert";

export default {
  name: "ShowDealers",
  components: {Rute, CreateDealers},
  data() {
    return {
      tableData: [],
      page_count: 0,
      value: 1
    }
  },
  watch: {
    'value': function () {
      console.log(this.value)
      dealers_service.GetAllDealerPagination((this.value * 10) - 10)
    },
    'tableData': function () {
      if (this.tableData.length === 0) {
        dealers_service.GetAllDealers()
      }
    }

  },
  methods: {
    ShowDealer() {
      bus.Show_Modal()
    },
    EditUser(user_id) {
      const u = _.find(this.tableData, function (item) {
        return item.user_id === user_id
      })
      bus.GetEditDealer(u)
    },
    OpenRute(user_id){
      const u = _.find(this.tableData, function (item) {
        return item.user_id === user_id
      })
      bus.OpenRute(u,user_id)
    },
    DeleteUser(user_id) {
      var f = new Date()
      let day = f.getDate()
      let month = f.getMonth() + 1
      let year = f.getFullYear()
      let fecha = ''
      if (month < 10) {

        fecha = `${year}/0${month}/${day}`
      } else {
        fecha = `${year}/${month}/${day}`

      }
      const data = {
        user_id: user_id,
        deletedAt: fecha
      }
      swal("¿Seguro que desea eliminar el usuario?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {
              case "Aceptar":
                dealers_service.DeleteUser(data)
                break;
            }
          });
    }
  },
  created() {

    bus.$on('AllDealers', (users, value) => {
      this.tableData = users
      this.page_count = Math.ceil(value / 10)
      this.value = 1
    })
    bus.$on('GetAllDealerPagination', (users) => {
      this.tableData = users
    })
    bus.$on('DeleteUser', (response) => {
      if (response.data) {
        dealers_service.GetAllDealers()
        swal({
          dangerMode: true,
          icon: "success",
          text: "Se Elimino Correctamente.",
          button: "Aceptar"
        })
      }else{
        dealers_service.GetAllDealers()
        swal({
          dangerMode: true,
          icon: "error",
          text: "¡No Se Elimino! Intenta de nuevo.",
          button: "Aceptar"
        })
      }

    })

  }
}
</script>

<style scoped>

</style>
